import {useState, React, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { db, auth, app, storage, database } from '../../../setup/Firebase';
import { getDatabase, ref, set, child, get, onValue } from "firebase/database";
import { getStorage, getDownloadURL, ref as storageRef } from 'firebase/storage'

import "./chart.css"

export default function Chart(props) {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const [imageCache, setImageCache] = useState({});

  const handleImageClick = (src) => {
    if (!isFullscreen) {
      console.log("test")
      setCurrentImage(src);
      setIsFullscreen(true);
    }

  };

  const handleClose = () => {
    console.log("test2")
    setIsFullscreen(false);
  };

  function Image({ url }) {
    const [images, setImages] = useState();

    useEffect(() => {
      const fetchImages = async () => {
        const cachedImage = localStorage.getItem(url);
        if (cachedImage) {
          setImages(cachedImage); // Use cached image
        } else {
          try {
              const result = await getDownloadURL(storageRef(storage, url));
              localStorage.setItem(url, result); // Cache the image URL
              console.log(result);
              setImages(result);
          } catch (error) {
              console.error('Error getting url', error);
              // Handle error gracefully, e.g., display an error message to the user
          }
        };
      }
      fetchImages(); // Call fetchImages inside useEffect
    }, []); // Empty dependency array ensures the effect runs only once on initial render

      return <img src={images} alt="image" />;
  }
  return (
    <div className='emas__chart' onClick={() => handleImageClick(props.url)}>
        <Image className='emas__chart-img' key={props.url} url={props.url} alt={props.alt}/>
        {isFullscreen && (
          <div className="emas__chart-fullscreen" onClick={handleClose}>
            <Image key={props.url} url={props.url} alt={props.alt}/>
          </div>
        )}
        <div className='emas__chart-heading'><h1>{props.title}</h1></div>
        <div className='emas__chart-date'><i>{props.date}</i></div>
        <div className='emas__chart-description'><p>{props.description}</p></div>
    </div>
  )
}
